










import { TREE_NODE_TYPE_META } from '@/features/domain-ui/tree-node-type/constants';
import { ExportColumn } from '@/features/ui/data-export/model';
import { TreeNodeType } from '@/types/iot-portal';
import { ArrayProp, BooleanProp } from '@/util/prop-decorators';
import { groupBy } from 'lodash';
import moment, { Moment } from 'moment';
import { Component, Vue } from 'vue-property-decorator';
import { generateBookmarkTokenUrl } from '../activity-tree-node-bookmark/util';
import { ActivityTreeNodeBookmarksUrlExportBookmark } from './model';

interface ProcessedBookmark {
  url: string;
  floor?: string;
  pathTypes: Record<TreeNodeType, string[]>;
}

@Component
export default class ActivityTreeNodeBookmarksUrlExport extends Vue {
  @ArrayProp(() => [])
  private readonly bookmarks!: ActivityTreeNodeBookmarksUrlExportBookmark[];

  @BooleanProp()
  private readonly disabled!: boolean;

  private readonly baseColumns: ExportColumn[] = [
    { name: 'floor', label: 'Etage' },
    { name: 'url', label: 'URL' },
  ];

  private get processedBookmarks(): ProcessedBookmark[] {
    return this.bookmarks.map(({ token, treeNode }) => ({
      url: generateBookmarkTokenUrl(token),
      floor:
        treeNode.__typename === TreeNodeType.PropertySubdivision
          ? treeNode.floor.name ?? String(treeNode.floor.level)
          : undefined,
      pathTypes: Object.fromEntries(
        Object.entries(groupBy(treeNode.path.items, '__typename')).map(([type, nodes]) => [
          type,
          nodes.map(({ name }) => name),
        ]),
      ) as Record<TreeNodeType, string[]>,
    }));
  }

  private get pathColumns(): ExportColumn[] {
    const counts: Partial<Record<TreeNodeType, number>> = {};

    for (const { pathTypes } of this.processedBookmarks) {
      for (const [type, { length }] of Object.entries(pathTypes) as [TreeNodeType, string[]][]) {
        counts[type] = Math.max(counts[type] ?? 0, length);
      }
    }

    function* generateColumns(type: TreeNodeType, count: number): Generator<ExportColumn> {
      for (let i = 0; i < count; i++) {
        yield {
          name: type + (count > 1 ? i + 1 : ''),
          label: TREE_NODE_TYPE_META[type].label + (count > 1 ? ` ${i + 1}` : ''),
          accessor: `pathTypes.${type}[${i}]`,
        };
      }
    }

    return Object.entries(counts).flatMap(([type, count]) => [...generateColumns(type as TreeNodeType, count ?? 0)]);
  }

  private get exportColumns(): ExportColumn[] {
    return this.pathColumns.concat(this.baseColumns);
  }

  private now(): Moment {
    return moment();
  }
}
